import { GetBrandService } from 'services';

export function BrandPopulate() {

  const populate = async () => {

    let itens = await GetBrandService();

    itens = itens ? itens : [];

    return itens.map(element => {

      const model = {
        id: {
          content: element.id,
          type: 'id'
        },
        brand: {
          content: element.name,
          type: 'brand',
        },
        phrase: {
          content: element.phraseSend,
          type: 'phrase',
        },
        active: {
          content: element.enabled,
          type: 'switch'
        },
        action: {
          content: null,
          type: 'edit'
        }
      };

      return model;

    })
  }

  return { content: populate() };
}
